import React from 'react';
import { Link } from 'react-router-dom';
import './Header.scss';

const Header: React.FC = () => {
  return (
    <header className="site-header">
      <div className="site-header__inner">
        <Link to="/" aria-label="Inicio de Codetrend" className="site-header__brand">
          <img
            src="/images/NewLogo.png"
            alt="Codetrend"
            className="site-header__logo"
          />
        </Link>
      </div>
    </header>
  );
};

export default Header;
